/*
 * `@backstage/cli` sits in devDependencies on purpose: from `dependencies` it
 * drags keytar into the production tree, and building the image then fails on
 * the native module. This import only pulls in ambient asset typings, which
 * cost nothing at runtime — so the rule is silenced here rather than obeyed.
 */
// eslint-disable-next-line @backstage/no-undeclared-imports
import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
